module.exports = __webpack_public_path__ + "static/media/truck-img2.aff783f4.png";